import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/main.scss";
import App from "./App";
import { initGoogleAnalytics } from "./googleAnalytics";

initGoogleAnalytics();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
